// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2OWNH","tab":"ProcedureTabs_tab__d_76b"};